import { useQuery } from '@tanstack/react-query';
import API from '../Job/API';
import { IError } from '../SmartForms/types';

export const useEmailTemplatesOptions = ({
  onError,
  type
}: {
  onError: (message: string) => void;
  type?: string;
}) => {
  return useQuery({
    queryKey: ['email templates'],
    queryFn: async () => {
      const { email_templates } = await API.getEmailTemplates(type);
      const result: string[] = [];
      email_templates.forEach((group: [string, { id: number; name: string }[]]) => {
        group[1].forEach((template) => {
          result.push(`${template.id} - ${template.name}@-*@${group[0]}`);
        });
      });
      return result;
    },
    onError: (error: IError) => onError(error.errors.join(', '))
  });
};
